import { render, staticRenderFns } from "./TreeSelectField.vue?vue&type=template&id=60a84743&scoped=true"
import script from "./TreeSelectField.vue?vue&type=script&lang=js"
export * from "./TreeSelectField.vue?vue&type=script&lang=js"
import style0 from "./TreeSelectField.vue?vue&type=style&index=0&id=60a84743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a84743",
  null
  
)

export default component.exports